const hostname = window && window.location && window.location.hostname;

export const inDev = hostname === "localhost";
// Covers app.freshpaint-staging.com plus any staging subdomain, including
// per-PR previews like pr-42.study.freshpaint-staging.com.
export const inStaging =
  hostname != null && hostname.endsWith(".freshpaint-staging.com");

// Per-PR preview builds (pr-<n>.study.freshpaint-staging.com). A narrower
// subset of inStaging for call sites that specifically need to distinguish
// an ephemeral preview build from the real staging app, e.g. the preview
// banner or the Freshpaint-employee-only gate in App.tsx.
export const isStudyPreview =
  hostname != null && hostname.endsWith(".study.freshpaint-staging.com");

let backendHost;
let apiV2Host;
let impressionPixelBaseURI;
let liveviewURL;
let sentryDSN;
let videoHostingDomain;

if (inDev) {
  backendHost = "http://localhost:8080";
  apiV2Host = "http://localhost:8081";
  impressionPixelBaseURI = "http://localhost:8094/pixel.png";
  liveviewURL = "ws://localhost:8090";
  sentryDSN = "https://8c749c95ea7e4b329e997e8a8be3377a@sentry.io/1863683";
  videoHostingDomain = "freshpaint-video.com";
} else if (inStaging) {
  backendHost = "https://api.freshpaint-staging.com";
  apiV2Host = "https://api-v2.freshpaint-staging.com";
  impressionPixelBaseURI =
    "https://freshpaint-impression-staging.com/pixel.png";
  liveviewURL = "wss://liveview.freshpaint-staging.com";
  sentryDSN = "https://8c749c95ea7e4b329e997e8a8be3377a@sentry.io/1863683";
  videoHostingDomain = "freshpaint-video-staging.com";
} else {
  backendHost = "https://api.freshpaint.io";
  apiV2Host = "https://api-v2.freshpaint.io";
  impressionPixelBaseURI = "https://freshpaint-impression.com/pixel.png";
  liveviewURL = "wss://liveview.freshpaint.io";
  sentryDSN =
    "https://ef21917de41d42fa8ab422c2267696fd@o334625.ingest.sentry.io/4504730766540800";
  videoHostingDomain = "freshpaint-video.com";
}

export const LIVEVIEW_URL = liveviewURL;
export const IMPRESSION_PIXEL_BASE_URI = impressionPixelBaseURI;
export const API_ROOT = `${backendHost}`;
export const API_V2_ROOT = `${apiV2Host}`;
export const DSN = sentryDSN;

// not set up for staging since we tabled forms
let formResourceURL;
let formConfigURL;
let formSubmitURL;
if (inDev) {
  formResourceURL = "http://localhost:9090/freshpaint-cdn.com/forms";
  formConfigURL = "http://localhost:9090/freshpaint-forms.com/configs";
  formSubmitURL = "http://localhost:8180/form_submission";
} else {
  formResourceURL = "https://freshpaint-cdn.com/forms";
  formConfigURL = "https://freshpaint-forms.com/configs";
  formSubmitURL =
    "https://b3yabdl4m8.execute-api.us-west-2.amazonaws.com/prod/form_submission";
}
export const FORM_RESOURCE_URL = formResourceURL;
export const FORM_CONFIG_URL = formConfigURL;
export const FORM_SUBMIT_URL = formSubmitURL;
export const VIDEO_HOSTING_DOMAIN = videoHostingDomain;
